import React from "react";
import { connect } from "react-redux";
import { View, ViewTitle } from "../../shared/styled/view";
import Loader from "../../shared/icons/tat/loader";
import FilterBarCompact from "../../shared/component/filter/filter-bar-compact";
import { cancelMultipleRequests, createEntity, partialEntity, readEntities, readEntity } from "../../redux/api/actions";
import { getCurrentCommandTabSelected, getTimeZone, sendMessageToMultipleUsersInSocket, setCurrentCommandTabSelected, showSimpleFlashNotification } from "../../shared/utils";
import OptionSelectorSwitch from "../../shared/controls/option-selector-switch";
import ImageWithCheckMark from "../../shared/component/image-with-check-mark";
import { getUrlsEnv } from "../../shared/backend-api";
import { OrderTableView } from "./tables/order-table-view";
import { OrderDetailTableView } from "./tables/order-detail-table-view";
import { getEntityItems } from "../../redux/api";
import ConfirmOrderModal from "../../shared/dialog/confirm-order-modal";
import ChangeDateModal from "../../shared/dialog/change-date-modal";
import ConvertOrdersToTrip from "../../shared/dialog/convert-orders-to-trip";
import PaginatorControlled from "../../shared/controls/paginator-controlled";
import GenericDialog from "../../shared/dialog/generic-modal";
import CatalogSelectionFooter from "../../shared/component/catalog-selection-footer";
import { setOrderSeleted } from "../../redux/reducers/global-catalog.reducer";
import styled from "styled-components";

const TRANSACTIONS = [
  { description: "Compra", value: 1 },
  { description: "Venta", value: 2 },
]

class OrdersControlView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      current_facilities: [],
      facilities_selected: [],
      facilityData: null,
      orderDetail: null,
      transactionType: 1,

      offset: 1,
      limit: 50,
      emails: [], 
      searchStr: "",
      appointment: [],
      appointment_type: [],
      requisition_status: [],
      facilities_selected: [],
      buttonFilterName: "Aplicar",
      getOrdersCalled: false,
      requisitionId: null,
      test_modal: null,
      confirmOrder: null,
      modifyAppointmentUnloading: null,
      modifyAppointmentLoading: null,
      convertToTrip: null,
      facilityCatalog: [],
      deliveryFilter: null,
      orderFilter: null,
      codesNotFound: [],
      seed: Math.random(),
      cancelOrder: null,
      ordersSelected: [],
      isAllOrdersSelected: false,
      cancelOrdersModal: false,
      errorMessage: null,
      editProviderTransportClassOrder: null,
      editClientTransportClassOrder: null,
      cancelAppointmentLoading: null,
      cancelAppointmentUnloading: null,
      finalizeOrder: null
    }
  }

  componentDidMount() {
    let current_tab = getCurrentCommandTabSelected();

    if (current_tab) {
      this.state.transactionType = current_tab.second_tab;
    }

    if (this.props.location.search.includes('facilities')) {
      const query = new URLSearchParams(this.props.location.search);

      let codes = `${query.get('codes') || ''}`;

      this.setState({
        current_facilities: `${query.get('facilities')}`.split(',').map(item => parseInt(item)),
        facilities_selected: `${query.get('facilities')}`.split(','),
        emails: codes === '' ? [] : codes.split(',').map( item => ({
          email: item, avatar: 'hide', avatarType: '', userId: null
        }))
      }, () => {

        // if (this.state.current_facilities.length === 1) {
        //   this.props.loadFacilityInfo({
        //     company_id: this.props.companyId,
        //     id: this.state.current_facilities[0]
        //   }, {
        //     onSuccess: (response) => {
        //       this.setState({
        //         facilityData: response
        //       });
        //     }
        //   });
        // }

        this.props.loadOrderStatus();
        this.loadFacilities();
        this.props.loadCompanyTags({
          company_id: this.props.companyId
        });

        this.props.loadOrderFilterConfig({
          company_id: this.props.companyId
        }, {
          onSuccess: (response) => {
            this.state.deliveryFilter = response.delivery_filter || null;
            this.state.orderFilter = response.order_filter || null;
            this.loadItems();
          },
          onError: () => {
            this.loadItems();
          }
        });

      });
    }

  }

  loadFacilities = () => {
    this.props.loadOwnFacilities({
      company_id: this.props.companyId,  
    }, {
      onSuccess: (response) => {

        let tags = Object.entries(response);
        let all_facilities_group = [];

        tags.map( (item, index) => {

          if (item.length > 1) {

            let item_to_add = {
              id: index,
              description: `${item[0]}` === 'null' ? 'Sin tag' : item[0],
              label: `${item[0]}` === 'null' ? 'Sin tag' : item[0]
            }
            let facilities = [];

            (item[1] || []).map( item_2 => {

              facilities.push({
                id: item_2.id,
                description: `${item_2.name}`,
                label: `${item_2.name} - ${item_2.alias} - ${item_2.code}`,
                value: `${item_2.id}`,
              });

            });

            item_to_add.items = facilities;
            item_to_add.options = facilities;

            if (facilities.length > 0) {
              all_facilities_group.push(item_to_add);
            }

          }

        });

        this.setState({
          facilityCatalog: all_facilities_group,
        });
      }

    });
  }

  loadItems = () => {
    if (this.state.getOrdersCalled) {
      this.props.cancelMultipleRequests();
    }

    this.setState({ getOrdersCalled: true });

    let codes = this.state.emails.map( item => item.email);
    let params = {};

    if (codes.length > 0) {
      params = {
        company_id: this.props.companyId,
        from_facility: this.state.transactionType === 2 ? this.state.facilities_selected : '',
        to_facility: this.state.transactionType === 1 ? this.state.facilities_selected : '',
        appointment: '',
        appointment_type: '',
        order_status: '',
        order_codes: codes,
        limit: this.state.limit,
        offset: this.state.offset,
        isMultipleCancels: true,
        timezone: getTimeZone()
      };
    } else {
      params = {
        company_id: this.props.companyId,
        from_facility: this.state.transactionType === 2 ? this.state.facilities_selected : '',
        to_facility: this.state.transactionType === 1 ? this.state.facilities_selected : '',
        appointment: this.state.appointment[0] ? "".concat(this.state.appointment[0].toISOString(), ",", this.state.appointment[1] ? this.state.appointment[1].toISOString() : this.state.appointment[0].toISOString()) : "",
        appointment_type: this.state.appointment_type,
        order_status: this.state.requisition_status,
        order_codes: '',
        limit: this.state.limit,
        offset: this.state.offset,
        isMultipleCancels: true,
        timezone: getTimeZone()
      };
    }

    this.props.loadFacilityOrders(params, {
      onSuccess: response => {
        if (this.state.requisitionId !== null) {
          (response.results || []).map( item => {
            if (item.id === this.state.requisitionId) {
              this.state.orderDetail = item; 
            }
          });
        }

        if (codes.length > 0) {
          this.state.codesNotFound = [];
          codes.map(code => {
            let requisition_found = (response.results || []).find( order => order.order_code.toLowerCase().includes(code.toLowerCase()) );

            if (!requisition_found) {
              this.state.codesNotFound.push(code);
            }
          })

        }

        this.setState({seed: Math.random(), requisitionId: null});
      }
    });
  }

  isSellingOrder = () => {
    if (this.state.orderDetail) {
      let facility_id = this.state.orderDetail?.from_facility?.id || 0;
      return this.state.current_facilities.includes(facility_id);
    }

    return false;
  }

  getTitleValue = () => {
    if (this.state.facilityData) {
      return this.state.orderDetail !== null ? `Detalle de Orden de ${this.isSellingOrder() ? 'Venta' : 'Compra'}` : `Control de Órdenes ${this.state.facilityData["name"] || ""}`;
    }

    return this.state.orderDetail !== null ? `Detalle de Orden de ${this.isSellingOrder() ? 'Venta' : 'Compra'} ${this.state.orderDetail?.order_code}` : 'Control de Órdenes';
  }

  filterContent = () => {
    let dateTypes = [
      {
        id: "1",
        description: "Carga"
      },
      {
        id: "2",
        description: "Descarga"
      },
      {
        id: "3",
        description: "Fecha de creación de orden"
      },
      {
        id: "4",
        description: "Fecha de cancelación"
      },
      {
        id: "5",
        description: "Fecha de confirmación"
      }
    ];

    return(
      [
        {
          title: "Instalaciones",
          items:  this.state.facilityCatalog,
          name: "facilities_selected",
          listType: 5,
        },
        {
          title: "Fecha",
          name: "appointment",
          listType: 7,
          time: true
        },
        {
          title: "Tipo fecha",
          items: dateTypes,
          name: "appointment_type",
          listType: 5
        },
        {
          title: "Estatus",
          items: this.props.orderStatuses,
          name: "requisition_status",
          listType: 5
        }
      ]
    );
    
  }

  resetModal = () => {
    this.setState({
      productsToAdd: [],
      selectedProvider: 0,
      selectedFacility: 0,
      selectedTags: [],
      selectedOrdersId: [],
      selectedCode: "",
      selectedDate: null,
      selectedLevel: 1,
      selectedClass: 0,
      providerProducts: [],
      providerFacilities: [],
      selectedDestiny: 0
    })
  }

  handleTabChange = (e) => {
    const { name, value } = e.target; 

    if (name === 'transactionType') {
      setCurrentCommandTabSelected(null, value, null);
      this.state.orderDetail = null;
    }

    this.setState({ [name]: value, selectedOrdersId: [], offset: 1}, () => {this.loadItems()});
  };

  getDetailHeader = () => {
    if (this.state.orderDetail === null) {
      return '';
    }

    let from_company = this.state.orderDetail.from_company;
    let to_company = this.state.orderDetail.to_company;

    return(
      <div style={{display: 'flex', marginLeft: 18}}>

        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
          <div style={{fontWeight: 800}}>{'Proveedor:'}</div>
          <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
            <ImageWithCheckMark
              src={getUrlsEnv().files.concat(from_company.logo?.substring(1) || '')}
              width={45}
              isCheckMark={from_company.verification_status === 3}
              customStyle={{
                width: 45, height: 45, borderRadius: '50%', position: 'relative', marginRight: 12
              }}
              type={from_company.type_id}
            />
            
            <div style={{fontSize: 22}}>{`${from_company.orbi_id}`}</div>
          </div>
        </div>

        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginLeft: 20}}>
          <div style={{fontWeight: 800}}>{'Cliente:'}</div>
          <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
            <ImageWithCheckMark
              src={getUrlsEnv().files.concat(to_company.logo?.substring(1) || '')}
              width={45}
              isCheckMark={to_company.verification_status === 3}
              customStyle={{
                width: 45, height: 45, borderRadius: '50%', position: 'relative', marginRight: 12
              }}
              type={to_company.type_id}
            />
            
            <div style={{fontSize: 22}}>{`${to_company.orbi_id}`}</div>
          </div>
        </div>

      </div>
    );
  }

  getFacilitiesDetailHeader = () => {
    if (this.state.orderDetail === null) {
      return '';
    }

    let from_facility = this.state.orderDetail.from_facility;
    let from_facility_company = this.state.orderDetail.from_facility?.company;
    let to_facility = this.state.orderDetail.to_facility;
    let to_facility_company = this.state.orderDetail.to_facility?.company;

    return(
      <div style={{display: 'flex'}}>

        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
          <div style={{fontWeight: 800}}>{'Origen:'}</div>

          <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
            {
              from_facility_company ?
              <ImageWithCheckMark
                src={getUrlsEnv().files.concat(from_facility_company.logo?.substring(1) || '')}
                width={45}
                isCheckMark={from_facility_company.verification_status === 3}
                customStyle={{
                  width: 45, height: 45, borderRadius: '50%', position: 'relative', marginRight: 12, marginLeft: 18
                }}
                type={from_facility_company.type_id} 
              /> : <div/>
            }

            <div>{`${from_facility.name}, ${from_facility_company.orbi_id ?? ''}`}</div>
          </div>

        </div>

        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
          <div style={{fontWeight: 800}}>{'Destino:'}</div>
          
          <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
            {
              to_facility_company ?
              <ImageWithCheckMark
                src={getUrlsEnv().files.concat(to_facility_company.logo?.substring(1) || '')}
                width={45}
                isCheckMark={to_facility_company.verification_status === 3}
                customStyle={{
                  width: 45, height: 45, borderRadius: '50%', position: 'relative', marginRight: 12, marginLeft: 18
                }}
                type={to_facility_company.type_id} 
              /> : <div/>
            }

            <div>{`${to_facility.name}, ${to_facility_company.orbi_id ?? ''}`}</div>
          </div>

        </div>
      </div>
    );

  }

  getHeaderInfoSelection = () => { 
    if (this.state.orderDetail) {
      return(
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: 20,
            color: '#afc8ff'
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '100%',
              backgroundColor: 'rgb(29, 37, 52)',
              borderRadius: '15px 15px 0px 0px',
              height: 100
            }}
          >
            {this.getDetailHeader()}

            {this.getFacilitiesDetailHeader()}

            <div 
              style={{display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: 28, cursor: 'pointer'}}
              onClick={() => this.setState({orderDetail: null, productsSelected: [], isAllProductsSelected: false})}
            >
              <div style={{fontSize: 18}}>{'ᐸ Regresar a Órdenes'}</div>
            </div>
          </div>
        </div>
      );
    } else {
      return(
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: '#afc8ff'
          }}
        >
          {/* <div style={{height: 60}}/> */}
        </div>
      );
    }
  }

  handleOrderChange = (e) => { 
    const name = e.target.name;
    const value = e.target.value;

    switch(name) {
      case 'load_items':
        this.loadItems();
        break;

      default:
        console.log('no action order');
    }

  }

  handleOrderGridChange = (e) => { 
    const name = e.target.name;
    const value = e.target.value;

    switch(name) {
      case 'finalize-order':
        this.setState({finalizeOrder: value});
        break;
      case 'cancel-appointment-unloading':
        this.setState({cancelAppointmentUnloading: value});
        break;
      case 'cancel-appointment-loading':
        this.setState({cancelAppointmentLoading: value});
        break;
      case 'edit_client_transport_class_order':
        this.setState({editClientTransportClassOrder: value});
        break;
      case 'edit_provider_transport_class_order':
        this.setState({editProviderTransportClassOrder: value});
        break;
      case 'modify-appointment-unloading':
        this.setState({
          modifyAppointmentUnloading: value
        });
        break;
      case 'orders_selected':
        this.setState({
          ordersSelected: value
        });
        break;
      case 'confirm_order':
        this.setState({confirmOrder: value});
        break;
      case 'entarimar':
        this.setState({
          test_modal: value
        });
        break;
      case 'cancel-order':
        this.setState({
          cancelOrder: value
        });
        break;
      case 'convert-to-trip':
        this.setState({
          convertToTrip: value
        });
        break;
      case 'modify-appointment-loading':
        this.setState({
          modifyAppointmentLoading: value
        });
        break;
      case 'modify-appointment-unloading':
        this.setState({
          modifyAppointmentUnloading: value
        });
        break; 
      case 'order_selected':
        // if (this.state.test_modal !== null || this.state.confirmOrder !== null || this.state.modifyAppointmentUnloading || this.state.modifyAppointmentLoading || this.state.convertToTrip) break;

        if (value.trip_id) {
          this.props.setOrderDetail(value.order_code);
          this.props.history.push(`/company/controls/shipment/orderdetail/${value.trip_id}/?transaction=true`);
        } else {
          this.props.history.push(`/company/controls/shipment/orderdetail/${value.order_id}/?isOrder=true&transaction=true`);
        }

        break;
      case 'trip_selected':
        this.props.history.push(`/company/controls/shipment/orderdetail/${value.trip_id}/?transaction=true`);
        break;
      default:
        console.log('no action');
    }
  }

  getCount = () => {
    return this.props.ordersCount;
  }

  handleEmailInput = (e) => {
    if (e) {
      switch (e.target.name) {
        case "inviteTags":
          let mails = e.target.value
            .map((i) => ({
              email: i.email,
              avatar: "hide",
              avatarType: "",
              userId: null,
            }));
          this.setState({ 
            emails: mails, 
            searchStr: e.target.value.map(e => e.email), 
            offset: 1,
            buttonFilterName: "Aplicar"
          }, this.loadItems);
          break;
        case "deleteTags":
          this.setState({ emails: [].concat(e.target.value), searchStr: e.target.value.map(e => e.email), offset: 1 }, this.loadItems);
          break;
        default:
      }
    }
  };

  getCancelOrdersErrors = () => {

    let orders_with_error = (this.state.ordersSelected || []).filter( item => [8,9,11].includes(item.status?.id || 0) );

    if (orders_with_error.length > 0) {
      return `Las órdenes ${ orders_with_error.map( item => item.code).join(', ') } no están en estatus para cancelar`;
    }

    return null;
  }

  callCancelOrders = (data) => {

    this.props.callActionsOrder(data, {
      onSuccess: (response) => {

        let correct_messages = [];
        let error_messages = [];

        if (response.response_msg && response.response_msg.error && response.response_msg.error.length > 0) {
          error_messages = response.response_msg.error
        }

        if (response.errors && response.errors.length > 0) {
          error_messages = error_messages.concat(response.errors);
        }

        if (response.errors && response.response_msg.success && response.response_msg.success.length > 0) {
          correct_messages = response.response_msg.success
        }

        if (correct_messages.length > 0) {
          showSimpleFlashNotification('Se realizó el cambio con éxito', null);
          this.loadItems();
          this.state.cancelOrdersModal = false;
          this.state.cancelOrder = null;
          this.state.seed = Math.random();
          this.state.ordersSelected = []; 
          this.state.isAllOrdersSelected = false;
        }

        if (error_messages.length > 0) {
          this.state.cancelOrdersModal = false;
          this.state.cancelOrder = null;
          this.state.errorMessage = error_messages.join(', ');
        }

        if (response.notifications) {
          try {
            (response.notifications || []).map( item => {
              sendMessageToMultipleUsersInSocket(
                this.props.userId,
                item['users'],
                item['data']
              );
            });
          } catch(e) {
            console.log('error:', e)
          }
        }

        this.setState({});

      },
      onError: (e) => {
        this.setState({
          errorMessage: e.response?.data?.error || 'Ocurrió un error, intente de nuevo'
        })
      }
    })

  }

  render() {
    return (
      <View className="orders-control-view">

        {
          (this.props.isLoading) && 
          <div
            style={{
              position: "absolute",
              top: "0",
              left: "0",
              width: "100%",
              height: "100%",
              backgroundColor: "#00000080",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 1001,
              backdropFilter: "blur(3px)"
            }}
          >
            <div style={{display: "flex", alignItems: "center"}}>
              <Loader width="100px" height="100px"/>
              <div style={{color: "#fff", fontSize: "36px"}}>
                Cargando
              </div>
            </div>
            <div style={{color: "#fff", fontSize: "30px"}}>
              Si desea cancelar la consulta, presione ESC
            </div>
          </div>
        }

        <ViewTitle>
          <span>
            { this.getTitleValue() } 
          </span> 
        </ViewTitle>

        <div className="switches-container">
          <div/>
          
          {
            this.state.orderDetail !== null ? <div/> :
            <OptionSelectorSwitch
              value={this.state.transactionType}
              name="transactionType"
              onChange={this.handleTabChange}
              items={TRANSACTIONS}
            />
          }

          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'end',
              marginBottom: 30
            }}
          >
            {
              this.state.orderDetail ? <div style={{height: 32}}/> :
              <FilterBarCompact
                limit={350}
                multiText={true}
                searchStr={this.state.emails}
                searchPlaceholder={"Ingresa Número de Orden"}
                clearMultiText={() => this.setState({ emails: [], searchStr: "" })}
                searchAction={this.handleEmailInput}
                filterAction={() => {

                  if (this.state.buttonFilterName === "Aplicar") {
                    this.setState(
                      {
                        offset: 1,
                        buttonFilterName: "Restablecer"
                      },
                      () => { this.loadItems(); }
                    );
                  } else {

                    this.setState({
                      offset: 1,
                      emails: [], 
                      searchStr: "",
                      appointment: [],
                      appointment_type: [],
                      requisition_status: [],
                      facilities_selected: [],
                      buttonFilterName: "Aplicar"
                    }, () => { this.loadItems(); })

                  }
                }}
                buttonFilterName={this.state.buttonFilterName}
                content={this.filterContent()}
                onChange={(e) => {
                  this.setState({
                    [e.target.name]: e.target.value,
                    emails: [], 
                    searchStr: '', 
                    buttonFilterName: "Aplicar"
                  })
                }}
                selectedItems={{
                  appointment: this.state.appointment,
                  appointment_type: this.state.appointment_type,
                  requisition_status: this.state.requisition_status,
                  facilities_selected: this.state.facilities_selected
                }}
              />
            }
          </div>
        </div>

        <div className="content">

          <ResetButtonContainer>
            <div 
              className="reset-button"
              onClick={() => {

                this.setState({
                  orderFilter: {},
                  seed: Math.random()
                });

                this.props.updateOrderFilterConfig({
                  company_id: this.props.companyId,
                  order_filter: {}
                });

              }}
            >{'Reestablecer acomodo de columnas'}</div>
          </ResetButtonContainer>

          {
            this.getHeaderInfoSelection()
          }

          {
            this.state.orderDetail ?
            <OrderDetailTableView 
              key={this.state.seed}
              rowData={this.state.orderDetail.deliveries}
              orderDetail={this.state.orderDetail}
              handleChange={this.handleOrderGridChange}
              configuration={this.state.deliveryFilter || {}}
              isLoading={this.props.isUpdatingFiltersLoading}
              setNewFilter={(new_filter) => {
                this.setState({
                  deliveryFilter: new_filter
                });

                this.props.updateOrderFilterConfig({
                  company_id: this.props.companyId,
                  delivery_filter: new_filter
                });
              }}
            />
            :
            <OrderTableView
              key={this.state.seed}
              rowData={this.props.ordersData}
              transactionType={this.state.transactionType}
              handleChange={this.handleOrderGridChange}
              allSelected={this.state.isAllOrdersSelected}
              configuration={this.state.orderFilter || {}}
              isLoading={this.props.isUpdatingFiltersLoading}
              currentCompany={this.props.company}
              setNewFilter={(new_filter) => {
                this.setState({
                  orderFilter: new_filter
                });

                this.props.updateOrderFilterConfig({
                  company_id: this.props.companyId,
                  order_filter: new_filter
                });
              }}
            />
          }

          <div style={{
            visibility: (this.state.orderDetail !== null) ? 'hidden' : 'visible'
          }}>
            <PaginatorControlled
              itemCount={this.getCount()}
              onChange={(e) => {
                this.setState({ [e.target.name]: e.target.value }, () => {
                  if (this.state.getOrdersCalled === true) {
                    this.loadItems();
                  }
                });
              }}
              limit={this.state.limit}
              offset={this.state.offset}
            />
          </div>
        </div>

        {
          (this.state.ordersSelected.length > 0) &&
          <CatalogSelectionFooter
            key={`catalog-footer`}
            show={this.state.ordersSelected.length > 0}
            selectedElements={this.state.ordersSelected.length}
            selectAll={() => {
              this.setState({
                isAllOrdersSelected: true,
                seed: Math.random()
              });
            }}
            actions={[
              {
                description: "Cancelar Órdenes",
                error: this.getCancelOrdersErrors(),
                disabled: this.getCancelOrdersErrors() !== null,
                f: () => {
                  this.setState({cancelOrdersModal: true});
                }
              },
              {
                description: "Cerrar",
                f: () => {
                  this.setState({seed: Math.random(), ordersSelected: [], isAllOrdersSelected: false});
                },
              }
            ]}
          />
        }

        {
          this.state.confirmOrder &&
          <ConfirmOrderModal
            currentCompany={this.props.company} 
            orders={[this.state.confirmOrder]}
            tagsCatalog={this.props.orderTags}
            closeAction={() => this.setState({confirmOrder: null})}
            transactionType={this.state.transactionType}
            handleChange={this.handleOrderChange}
          />
        }

        {
          this.state.editProviderTransportClassOrder &&
          <ConfirmOrderModal
            currentCompany={this.props.company}
            editTransportClass={1} // provider
            orders={[this.state.editProviderTransportClassOrder]}
            tagsCatalog={[]}
            closeAction={() => this.setState({editProviderTransportClassOrder: null})}
            transactionType={this.state.transactionType}
            handleChange={this.handleOrderChange}
          />
        }

        {
          this.state.editClientTransportClassOrder &&
          <ConfirmOrderModal
            currentCompany={this.props.company}
            editTransportClass={2} // client
            orders={[this.state.editClientTransportClassOrder]}
            tagsCatalog={[]}
            closeAction={() => this.setState({editClientTransportClassOrder: null})}
            transactionType={this.state.transactionType}
            handleChange={this.handleOrderChange}
          />
        }

        {
          this.state.codesNotFound.length > 0 &&
          <GenericDialog
            open={this.state.codesNotFound.length > 0}
            title={'Órdenes no encontradas:'}
            message={`${this.state.codesNotFound.join(', ')}`}
            acceptAction={() => this.setState({codesNotFound: []})}
            closeAction={() => this.setState({codesNotFound: []})}
          />
        }

        {
          this.state.modifyAppointmentUnloading &&
          <ChangeDateModal
            editDate={this.state.modifyAppointmentUnloading.date}
            open={this.state.modifyAppointmentUnloading}
            onClose={() => {
              this.setState({
                modifyAppointmentUnloading: false
              });
            }}
            facilityId={this.state.modifyAppointmentUnloading.facility_id}
            orderId={this.state.modifyAppointmentUnloading.order_id}
            tripDetails={this.state.modifyAppointmentUnloading.trip_details}
            data={this.state.modifyAppointmentUnloading.data}
            date={new Date(this.state.modifyAppointmentUnloading.date)}
            reasons={this.props.orderMotives.filter((m) => m.type === 2)}
            loadTrips={() => {
              this.loadItems();
            }}
          />
        }

        { this.state.modifyAppointmentLoading &&
          <ChangeDateModal
            editDate={this.state.modifyAppointmentLoading.date}
            open={this.state.modifyAppointmentLoading}
            onClose={() => {
              this.setState({
                modifyAppointmentLoading: false
              });
            }}
            facilityId={this.state.modifyAppointmentLoading.facility_id}
            orderId={this.state.modifyAppointmentLoading.order_id}
            tripDetails={this.state.modifyAppointmentLoading.trip_details}
            data={this.state.modifyAppointmentLoading.data}
            date={new Date(this.state.modifyAppointmentLoading.date)}
            reasons={this.props.orderMotives.filter((m) => m.type === 2)}
            loadTrips={() => {
              this.loadItems();
            }}
          />
        }

        {
          this.state.convertToTrip &&
          <ConvertOrdersToTrip
            transactionType={this.state.transactionType}
            order={this.state.convertToTrip}
            tagsCatalog={this.props.tripTags}
            closeAction={() => {
              this.setState({
                convertToTrip: false
              });
            }}
            handleChange={this.handleOrderChange}
          />
        }

        {
          this.state.finalizeOrder &&
          <GenericDialog
            open={this.state.finalizeOrder !== null}
            title={'¿Estás seguro?'}
            message={`Esta acción finalizará esta orden sin datos ${this.state.finalizeOrder.order_code || ''} y será irreversible`}
            isLoading={this.props.isCallOrderLoading}
            acceptAction={() => {

              let params = {
                action: "finalize_order",
                company_id: this.props.companyId,
                view: '',
                id: this.state.finalizeOrder.order_id
              }

              this.props.callOrderActions(params, {
                onSuccess: () => {

                  this.setState({finalizeOrder: null});
                  showSimpleFlashNotification('Se realizó el cambio con éxito', null);
                  this.loadItems();
                  
                },
                onError: (e) => {
                  this.setState({
                    errorMessage: e.response?.data?.errors || 'Ocurrió un error, intente de nuevo'
                  })
                }
              });

            }}
            closeAction={() => {
              this.setState({finalizeOrder: null})}
            }
          />
        }

        {
          this.state.cancelAppointmentLoading &&
          <GenericDialog
            open={this.state.cancelAppointmentLoading !== null}
            title={'¿Estás seguro?'}
            message={`Esta acción cancelará la cita de carga de la orden ${this.state.cancelAppointmentLoading.order_code} y será irreversible`}
            isLoading={this.props.isCallOrderLoading}
            acceptAction={() => {

              let params = {
                company_id: this.props.companyId,
                action: 'cancel_appointment',
                view: 'load',
                id: this.state.cancelAppointmentLoading.order_id,
              };

              this.props.callOrderActions(params, {
                onSuccess: () => {

                  this.setState({cancelAppointmentLoading: null});
                  showSimpleFlashNotification('Se realizó el cambio con éxito', null);
                  this.loadItems();
                  
                },
                onError: (e) => {
                  this.setState({
                    errorMessage: e.response?.data?.error || 'Ocurrió un error, intente de nuevo'
                  })
                }
              });

            }}
            closeAction={() => {
              this.setState({cancelAppointmentLoading: null})}
            }
          />
        }

        {
          this.state.cancelAppointmentUnloading &&
          <GenericDialog
            open={this.state.cancelAppointmentUnloading !== null}
            title={'¿Estás seguro?'}
            message={`Esta acción cancelará la cita de descarga de la orden ${this.state.cancelAppointmentUnloading.order_code} y será irreversible`}
            isLoading={this.props.isCallOrderLoading}
            acceptAction={() => {

              let params = {
                company_id: this.props.companyId,
                action: 'cancel_appointment',
                view: 'unload',
                id: this.state.cancelAppointmentUnloading.order_id,
              };

              this.props.callOrderActions(params, {
                onSuccess: () => {

                  this.setState({cancelAppointmentUnloading: null});
                  showSimpleFlashNotification('Se realizó el cambio con éxito', null);
                  this.loadItems();
                  
                },
                onError: (e) => {
                  this.setState({
                    errorMessage: e.response?.data?.error || 'Ocurrió un error, intente de nuevo'
                  })
                }
              });

            }}
            closeAction={() => {
              this.setState({cancelAppointmentUnloading: null})}
            }
          />
        }

        {
          this.state.cancelOrder &&
          <GenericDialog
            open={this.state.cancelOrder !== null}
            title={'¿Estás seguro?'}
            message={`Esta acción cancelará la orden ${this.state.cancelOrder.order_code} y será irreversible`}
            isLoading={this.props.isOrdersLoading}
            acceptAction={() => {

              let data = {
                company_id: this.props.companyId,
                action: 'cancel_order',
                orders: [
                  this.state.cancelOrder.order_id
                ]
              };

              this.callCancelOrders(data);

            }}
            closeAction={() => {
              this.setState({cancelOrder: null})}
            }
          />
        }

        {
          this.state.cancelOrdersModal &&
          <GenericDialog
            open={this.state.cancelOrdersModal}
            title={'¿Estás seguro?'}
            message={`Esta acción cancelará las orden(es) ${ this.state.ordersSelected.map( item => item.code).join(', ') } y será irreversible`}
            isLoading={this.props.isOrdersLoading}
            acceptAction={() => {

              let data = {
                company_id: this.props.companyId,
                action: 'cancel_order',
                transaction_type: this.state.transactionType === 1 ? 'buy' : 'sell',
                orders: this.state.ordersSelected.map( item => item.id)
              };

              this.callCancelOrders(data);

            }}
            closeAction={() => {
              this.setState({cancelOrdersModal: false})}
            }
          />
        }

        {
          this.state.errorMessage !== null &&
          <GenericDialog
            open={this.state.errorMessage !== null}
            title={'Error'}
            message={this.state.errorMessage}
            acceptAction={() => this.setState({errorMessage: null})}
            closeAction={() => this.setState({errorMessage: null})}
          />
        }

      </View>
    );
  }

}

const mapStateToProps = (state) => {
  const companyId = state.globalCatalog.session.company.id;
  const isOrdersCatalogLoading = state?.api['COMPANIES.REQUISITIONSCONTROL.ORDERS.CATALOG2']?.status?.isFetching || false;
  const ordersData = getEntityItems(state, "COMPANIES.REQUISITIONSCONTROL.ORDERS.CATALOG2")["results"] || []; 
  const ordersCount = getEntityItems(state, "COMPANIES.REQUISITIONSCONTROL.ORDERS.CATALOG2")["count"] || 0;
  const companyTags = getEntityItems(state, "COMPANIES.TAGS"); 
  const orderTags = companyTags.filter(t => t.type === 7);
  const tripTags = companyTags.filter(t => t.type === 9);
  const isFiltersLoading = state?.api['COMPANIES.ORDERSCONTROL.FILTERCONFIGURATION']?.status?.isFetching || false;
  const isUpdatingFiltersLoading = state?.api['COMPANIES.ORDERSCONTROL.FILTERCONFIGURATION.UPDATE']?.status?.isFetching || false;
  const isOrdersLoading = state?.api['COMPANIES.REQUISITIONSCONTROL.ORDERS.ACTIONS']?.status?.isFetching || false;
  const isCallOrderLoading = state?.api['COMPANIES.ORDERS']?.status?.isFetching || false;

  let orderStatuses = getEntityItems(state,"COMPANIES.CATALOGS.ORDERSTATUS").map((f) => ({
    description: f.description,
    id: f.id || 0,
  }));

  const orderMotives = getEntityItems(state, "COMPANIES.CATALOGS.ORDERSMOTIVES")
    .map((o) =>
      o.submotives.map((s) => ({
        label: `${o.description} - ${s.description}`,
        value: s.id,
        type: s.type,
      }))
    )
    .flat();

  return {
    isCallOrderLoading,
    isOrdersLoading,
    orderMotives,
    companyId,
    ordersData,
    ordersCount,
    isLoading: isOrdersCatalogLoading || isFiltersLoading || isOrdersLoading,
    orderTags,
    tripTags,
    orderStatuses,
    isUpdatingFiltersLoading,
    company: state.globalCatalog.session.company
  };
}

const mapDispatchToProps = (dispatch) => {
  dispatch(readEntities("COMPANIES.CATALOGS.ORDERSMOTIVES"));

  return {
    cancelMultipleRequests: () => dispatch(cancelMultipleRequests()),
    loadFacilityOrders: (params, opt) => dispatch(readEntities("COMPANIES.REQUISITIONSCONTROL.ORDERS.CATALOG2", params, opt)),
    loadFacilityInfo: (params, opt) => dispatch(readEntity("COMPANIES.FACILITIES", params, opt)),
    loadOwnFacilities: (params, opt) => dispatch(readEntities("COMPANIES.FACILITIES.TAGS", params, opt)),
    loadCompanyTags: (params, opts) => dispatch(readEntities("COMPANIES.TAGS", params, opts)),
    loadOrderStatus: () => dispatch(readEntities("COMPANIES.CATALOGS.ORDERSTATUS")),
    loadOrderFilterConfig: (params, opt) => dispatch(readEntity("COMPANIES.ORDERSCONTROL.FILTERCONFIGURATION", params, opt)),
    updateOrderFilterConfig: (params, opts) => dispatch(partialEntity("COMPANIES.ORDERSCONTROL.FILTERCONFIGURATION.UPDATE", params, opts)),
    callActionsOrder: (params, opt) => dispatch(createEntity("COMPANIES.REQUISITIONSCONTROL.ORDERS.ACTIONS", params, opt)),
    setOrderDetail: (payload) => dispatch(setOrderSeleted(payload)),
    callOrderActions: (params, opts) => dispatch(partialEntity("COMPANIES.ORDERS", params, opts)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OrdersControlView); 

const ResetButtonContainer = styled.div`
  width: 100%;
  display: flex;
  height: 25px;
  justify-content: right;
  align-items: center;
  margin-bottom: 10px;
  margin-top: 10px;

  & .reset-button {
    cursor: pointer;
    font-size: 16px;
    text-decoration: underline;
    color: white;

    &:hover {
      font-size: 18px;
    }
  }
`;